import type { QueryClient } from "@tanstack/react-query"
import { signOut } from "aws-amplify/auth"
import { Hub } from "aws-amplify/utils"

import { clearApiAuthCache } from "@/lib/api"
import { clearAuthCache, refreshAuthTokens } from "@/lib/auth/auth-store"

type HubPayload = {
	readonly event?: unknown
}

function getAuthEventName(payload: unknown): string | null {
	if (!payload || typeof payload !== "object") return null
	const event = (payload as HubPayload).event
	if (typeof event !== "string" || event.length === 0) return null
	return event
}

export function installAuthHubListeners(queryClient: QueryClient): void {
	Hub.listen("auth", ({ payload }: { payload: unknown }) => {
		const event = getAuthEventName(payload)
		if (!event) return

		if (event === "signedIn") {
			// A sign-in is a user boundary: discard the previous user's data instead
			// of invalidating every active query and refetching the whole dashboard.
			queryClient.clear()
			void refreshAuthTokens()
			.catch(() => undefined)
			return
		}

		if (event === "signedOut") {
			clearAuthCache()
			clearApiAuthCache()
			queryClient.clear()
			return
		}

		if (event === "tokenRefresh_failure") {
			clearAuthCache()
			clearApiAuthCache()
			queryClient.clear()
			void signOut().catch(() => undefined)
		}
	})
}
